<template>
  <div>
    <!-- 弹框： -->
    <transition name="myself-dialog-fade">
      <div class="showBox_father" v-if="dialogFlag">
        <div class="showBox_son" @click.stop :style="{width: this.width, padding: p_lr}" :class="{'outer_border': hasBorder}">
          <div v-if="hideMaskFlag" class="closeIcon iconfont icon-2guanbi cursor_pointer" @click="$emit('hideMask')"></div>
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    dialogFlag:{
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '380px'
    },
    p_lr: {
      type: String,
      default: '0 20px'
    },
    hideMaskFlag: {
      type: Boolean,
      default: true
    },
    hasBorder: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style lang="scss" scoped>
// 弹框：
.showBox_father {
  // @include showBoxFather();
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  overflow: auto;
  .showBox_son {
    height: auto;
    background-color: #fff;
    position: absolute;
    @include AnyElementCentered();
    display: flex;
    flex-direction: column;
    position: relative;
    border-radius: 10px;
    z-index: 15;
    .closeIcon {
      position: absolute;
      bottom: -50px;
      left: 50%;
      font-size: 30px;
      transform: translateX(-50%);
      color: #fff;
    }
  }
}

.outer_border {
  border: 4px solid #006AA6;
}
</style>